import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'view-config',
  imports: [CommonModule, TranslateModule],
  templateUrl: './view-config.component.html',
  styleUrl: './view-config.component.scss',
})
export class ViewConfigComponent {
  @Input() gridOption$!: BehaviorSubject<string>;
  @Input() changeView: ((option: string) => void) | undefined;

  selectGridOption(option: string) {
    this.changeView?.(option);
  }
}
